import { useQuery } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';

export const memberRequestSummaryKeys = {
  summary: (employerNumber) => ['memberRequest', 'summary', employerNumber],
};

export const useMemberRequestSummary = (employerNumber) => {
  return useQuery({
    queryKey: memberRequestSummaryKeys.summary(employerNumber),
    queryFn: async () => {
      const result = await serverRequest(
        'GET',
        `members/gcb/summary?employerNumber=${encodeURIComponent(employerNumber)}`
      );
      return result.data;
    },
    enabled: !!employerNumber,
    onError: (error) => {
      notifyUser('error', error, 'Error');
    },
  });
};
